
// Константа даты начала диагностики
export const DIAGNOSTICS_START_DATE = '2025-06-01';

export interface DiagnosticData {
  type: string;
  description: string;
  severity: 'info' | 'warning' | 'error';
  details: any;
  bike?: any;
  rental?: any;
  courier?: any;
  timestamp?: string;
}

export interface InconsistencyData {
  id: string;
  type: string;
  description: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  affectedEntity: 'bike' | 'rental' | 'courier' | 'payment' | 'system';
  entityId?: string;
  details: {
    expected?: any;
    actual?: any;
    difference?: number;
    deviation?: number;
    daysDeviation?: number; // Добавляем новое поле для отклонения в днях
    impact?: string;
    suggestions?: string[];
    rentalPeriod?: string;
    expectedAmount?: number;
    actualAmount?: number;
    timingIssue?: string;
    violationDegree?: string;
    timeViolation?: number;
    paymentDelay?: number;
    gpsTag?: string; // Добавляем поле для GPS тега
  };
  timestamp: string;
  bike?: any;
  rental?: any;
  courier?: any;
  payment?: any;
  // Добавляем поля для отображения статуса и периода аренды
  rentalStatus?: string;
  rentalPeriodDisplay?: string;
}

export interface SuspiciousRentalStats {
  totalSuspicious: number;
  byTariffType: {
    weekly: number;
    biweekly: number;
    monthly: number;
    yandex: number;
    unknown: number;
  };
  potentialLoss: number;
  coverageRate: number;
  detectionAccuracy: number;
  criticalUnderpayments: number;
  temporalViolations: number;
  earlyPayments: number;
  latePayments: number;
  rapidPayments: number;
}

export interface IoTStats {
  totalDevices: number;
  onlineDevices: number;
  offlineDevices: number;
  batteryIssues: number;
  connectionIssues: number;
  lastUpdateIssues: number;
  performanceIssues: number;
  totalBikes: number;
  withIoT: number;
  coveragePercent: number;
  activePercent: number;
  gpsDataQuality: number;
}

export interface FinancialStats {
  totalPayments: number;
  successfulPayments: number;
  failedPayments: number;
  pendingPayments: number;
  missingReceipts: number;
  amountDiscrepancies: number;
  totalRevenue: number;
  expectedRevenue: number;
  revenueLoss: number;
  successRate: number;
  receiptCoverage: number;
  canceledAuthorizations: number;
  authorizationIssues: number;
}

export interface DiagnosticsStats {
  totalBikes: number;
  activeBikes: number;
  inactiveBikes: number;
  blockedBikes: number;
  lowBatteryBikes: number;
  totalRentals: number;
  activeRentals: number;
  suspiciousRentals: number;
  totalRevenue: number;
  iotStats: IoTStats;
  suspiciousRentalStats: SuspiciousRentalStats;
  financialStats: FinancialStats;
}

export interface FilterState {
  selectedSeverity: string[];
  selectedType: string[];
  searchTerm: string;
  showOnlyIssues: boolean;
  // Поля для диапазона дат
  useCustomDateRange: boolean;
  dateFrom: Date;
  dateTo: Date;
  // Новые фильтры для аренд
  selectedRentalStatus: string[];
  ignoreOldRentals: boolean;
  ignoreCancelledRentals: boolean;
}

export interface DiagnosticsContextType {
  stats: DiagnosticsStats;
  inconsistencies: InconsistencyData[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
  // Добавляем недостающие свойства для совместимости с компонентами
  data: InconsistencyData[];
  filters: FilterState;
  setFilters: (filters: Partial<FilterState>) => void;
  refreshData: () => Promise<void>;
  exportData: () => void;
  isLoading: boolean;
}

// Маппинг статусов для велосипедов согласно базе данных
export const BIKE_STATUS_MAPPING = {
  available: 'Доступен',
  in_use: 'В аренде', // соответствует статусу 'active' у аренды
  maintenance: 'На обслуживании',
  lost: 'Потерян',
  inactive: 'Неактивен'
} as const;

// Маппинг статусов для аренд согласно базе данных  
export const RENTAL_STATUS_MAPPING = {
  active: 'Активная',
  completed: 'Завершена',
  cancelled: 'Отменена',
  pending: 'Ожидает'
} as const;

// Маппинг статусов для платежей согласно базе данных
export const PAYMENT_STATUS_MAPPING = {
  completed: 'Завершен',
  pending: 'В обработке',
  failed: 'Неудачный',
  cancelled: 'Отменен'
} as const;
